import React from 'react'
import { HashRouter, useRoutes } from 'react-router-dom'
import { AnimatePresence } from 'framer-motion'
import { routes } from './pages/routes'
import { usePersistQueryParam } from "@/utils/keepQuery"



const Router = () => {
  usePersistQueryParam('hideTop')
  const router = useRoutes(routes)
  return (
    <AnimatePresence mode="wait">
      {router}
    </AnimatePresence>
  )
}
const App = () => {
  return (
    <HashRouter>
      <Router />
    </HashRouter>
  )
}
export default App
